var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTxt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 64,
    viewBox: "0 0 48 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.84001C0.5 1.99514 1.99514 0.5 3.84001 0.5H31.8179L47.5001 13.673V60.16C47.5001 62.0049 46.0049 63.5 44.1601 63.5H3.84001C1.99514 63.5 0.5 62.0049 0.5 60.16V3.84001Z",
    stroke: "#6D7EAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 0V9.59996C32 11.721 33.719 13.44 35.84 13.44H48.0001",
    fill: "#6D7EAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7861 45H13.4863V36.1963H10.293V34.3359H19.0234V36.1963H15.7861V45Z",
    fill: "#6D7EAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0991 37.9468L26.0181 34.3359H28.6621L25.5933 39.624L28.7354 45H26.0693L24.0991 41.3232L22.1216 45H19.4556L22.605 39.624L19.5288 34.3359H22.1729L24.0991 37.9468Z",
    fill: "#6D7EAB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.668 45H32.3682V36.1963H29.1748V34.3359H37.9053V36.1963H34.668V45Z",
    fill: "#6D7EAB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.b2f876c2.svg";
export { ForwardRef as ReactComponent };